import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchOrders, searchOrders, filterOrders, sortOrders } from "../../actions/orderActions"
import OrderListItem from './OrderListItem'
import isEmpty from 'lodash/isEmpty'
import { sortOpts } from '../../utils/utils'

class OrderList extends React.Component {

  componentWillMount(){
    this.props.fetchOrders();
    window.scrollTo(0, 0);
  }

  createOrder = e => {
    e.preventDefault();
    this.context.router.push('/order/create');
  }

  handleSearch = e => {
    const searchQuery = e.target.value.toLowerCase();
    this.props.searchOrders(searchQuery);
  }

  changeSort(asc){
    if(asc === 0)
      return 1
    return 0
  }

  handleSort = sortField => {
    const currField = this.props.orders.sort.field;
    const currAsc = this.props.orders.sort.asc;
    const asc = sortField === currField ? this.changeSort(currAsc) : 1;
    this.props.sortOrders({field:sortField,asc:asc});
  }

  handleFilter = e => {
    e.preventDefault();
    const filter = this.props.orders.filter;
    const val = parseInt(e.target.value,10);
    for (var i = 0; i < filter.length; i++){
      if(filter[i] === val){
        this.props.filterOrders([
          ...filter.slice(0,i),
          ...filter.slice(i+1)
        ]);
        return false;
      }
    }
    this.props.filterOrders([
      ...filter,
      val
    ]);
  }

  clearSearch = () => {
    this.props.searchOrders('');
  }

  render() {
    if(isEmpty(this.props.sttss)
      || isEmpty(this.props.comps)
      || isEmpty(this.props.empls)
      || isEmpty(this.props.orders)
      || isEmpty(this.props.orders.data)
    ){
      return(<div>Не загружены данные</div>);
    }
    const orders = this.props.orders.data;
    const { comps, sttss, empls } = this.props;
    const { search, sort, filter } = this.props.orders;

    const fltrOrders = orders.filter(el =>{
      var found = true;
      var filtered = false;
      for (var i = 0; i < filter.length; i++){
        if(el.order_stts_id === filter[i]){
          filtered = true;
          break;
        }
      }
      if(search){
        const searchValue = el.order_desc.toString()
          +el.order_num+comps[el.order_comp_id].comp_desc.toString();
        found= searchValue.toLowerCase().indexOf(search) !== -1;
      }
      return filtered && found;
    });

    const sortField = sort.field;
    const sortAsc = sort.asc
    const sortedOrders = fltrOrders.sort( (a, b) => {
      if(sort.field === 'comp_desc' && comps.hasOwnProperty(a.order_comp_id)
        && comps.hasOwnProperty(b.order_comp_id)){
        if(comps[a.order_comp_id].comp_desc < comps[b.order_comp_id].comp_desc)
          return sort.asc ? -1 : 1
        if(comps[a.order_comp_id].comp_desc > comps[b.order_comp_id].comp_desc)
          return sort.asc ? 1 : -1
      }
      if(a[sortField] < b[sortField])
         return sortAsc ? -1 : 1
      if(a[sortField] > b[sortField])
         return sortAsc ? 1 : -1
      if(a.order_id < b.order_id)
         return sortAsc ? -1 : 1
      if(a.order_id > b.order_id)
         return sortAsc ? 1 : -1
      return 0
    });

    var mappedStts = [];
    var sttsColor = '';
    for (var key in sttss){
      if(sttss.hasOwnProperty(key) && sttss[key].stts_active) {
        sttsColor = (filter.indexOf(parseInt(key,10)) !== -1) ?
          sttss[key].stts_color_id : 'white';
        mappedStts.push(
          <button
            className="btn"
            style={{backgroundColor:sttsColor}}
            key={key}
            value={key}
            onClick={this.handleFilter}
          >
            {sttss[key].stts_desc}
          </button>
        );
      }
    }

    var sttsOpt = [];
    for (key in sttss){
      if(sttss.hasOwnProperty(key)) {
        sttsOpt.push({value:sttss[key].stts_id,label:sttss[key].stts_desc});
      }
    }
    sttsOpt.sort(sortOpts);

    const mappedOrders = sortedOrders ? sortedOrders.map(order =>
        <OrderListItem key={order.order_id}
          data={order}
          comp={comps[order.order_comp_id]}
          stts={sttss[order.order_stts_id]}
          empls={empls}
        />
      ) : '';

    const clearSearchBtn = search ? <button
        type="button"
        className="btn btn-default"
        onClick={this.clearSearch}
        title="Очистить поиск">
        X
      </button> :
      <button
        disabled
        type="button"
        className="btn btn-default"
        onClick={this.clearSearch}
        title="Очистить поиск">
        X
      </button>;

    return (
      <div>
        <div className="form-group">
          <form className="form-inline">
            <div className="pull-right">{mappedStts}</div>
            <button className="btn btn-primary" onClick={this.createOrder}>
              Создать
            </button>{" "}
            <div className="input-group">
              <input
                type="search"
                className="form-control"
                value={search}
                title="Поиск"
                placeholder="Поиск"
                onChange={this.handleSearch} />
              <div className="input-group-btn">
                {clearSearchBtn}
              </div>
            </div>
          </form>
        </div>
        <table className="table table-striped table-hover">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th onClick={()=>{this.handleSort('order_num',this)}}>№</th>
              <th onClick={()=>{this.handleSort('comp_desc',this)}} className="col-sm-3">Клиент</th>
              <th onClick={()=>{this.handleSort('order_desc',this)}} className="col-sm-4">Мероприятие</th>
              <th onClick={()=>{this.handleSort('order_empl2',this)}} className="col-sm-1">Менеджер</th>
              <th onClick={()=>{this.handleSort('order_edate',this)}} className="col-sm-1">Дата</th>
              <th onClick={()=>{this.handleSort('p1_srvcsum',this)}} className="col-sm-1 text-right">Сумма</th>
              <th onClick={()=>{this.handleSort('p1_balance',this)}} className="col-sm-1 text-right">Клиент</th>
              <th onClick={()=>{this.handleSort('p2_balance',this)}} className="col-sm-1 text-right">Подряд</th>
            </tr>
          </thead>
          <tbody>
            {mappedOrders}
          </tbody>
        </table>
      </div>
    )

  }
}

OrderList.contextTypes = {
  router: PropTypes.object.isRequired
}

function mapOrdersToProps(store) {
  return {
    orders: store.orders,
    comps: store.comps.data,
    sttss: store.sttss.data,
    empls: store.empls,
    settings: store.settings
  }
}

export default connect(mapOrdersToProps, { fetchOrders, searchOrders, filterOrders, sortOrders })(OrderList);



// WEBPACK FOOTER //
// ./src/components/order/OrderList.js